<div *ngIf="appointments && (appointments.length > 0)">
  <mc-appointment-show
            [patient]="patient"
            [appointments]="appointments"
            [prescriptions]="prescriptions"
            [exams]="exams"></mc-appointment-show>
</div>

<!-- Modal -->
<div class="modal fade" #createNewModal tabindex="-1" role="dialog" aria-labelledby="createNewModal" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Primeiro Atendimento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="goBack()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Nenhum atendimento foi encontrado para este paciente, gostaria de criar o primeiro atendimento?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="goBack()">Cancelar</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="createNew()">Criar</button>
      </div>
    </div>
  </div>
</div>
